// import axios from "axios";
// import queryString from "query-string";

// const API_URL = "https://app.akabiz.net";

// // Set up default config for http requests here
// // Please have a look at here `https://github.com/axios/axios#request- config` for the full list of configs
// const axiosClient = axios.create({
//   baseURL: API_URL,
//   headers: {
//     "content-type": "application/json",
//   },
//   paramsSerializer: (params) => queryString.stringify(params),
// });

// axiosClient.interceptors.response.use(
//   (response) => {
//     if (response && response.data) {
//       return response.data;
//     }

//     return response;
//   },
//   (error) => {
//     // Handle errors
//     throw error;
//   }
// );

// const userApi = {
//   login: (username, password) => {
//     const url = `/api/Auth/login?username=${username}&password=${password}`;
//     return axiosClient.get(url);
//   },
//   get: (id) => {
//     const url = `/api/Auth/getStaffById_ZaloExtension?id=${id}`;
//     return axiosClient.get(url);
//   },
//   getNoti: () => {
//     const url = `/api/Auth/getWebZaloNoti`;
//     return axiosClient.get(url);
//   },
// };

// export default userApi;

import axiosClient from "./axiosClient.js";

const userApi = {
  login: (username, password) => {
    const url = `/staffs/login`;
    return axiosClient.post(url, {
      username,
      password,
    });
  },
  get: (id) => {
    const url = `/staffs/get/${id}`;
    return axiosClient.post(url);
  },
  getByAccountId: (accountId) => {
    const url = `/staffs/getByAccountId/${accountId}`;
    return axiosClient.post(url);
  },
  getByFilter: (filter) => {
    const queryString = new URLSearchParams(filter).toString();
    const url = `/staffs/getByFilter?${queryString}`;
    return axiosClient.post(url);
  },
  create: (data) => {
    const url = `/staffs/create`;
    return axiosClient.post(url, data);
  },
  updateById: (data) => {
    const url = `/staffs/updateById`;
    return axiosClient.put(url, data);
  },
  updateMany: (data) => {
    const url = `/staffs/updateMany`;
    return axiosClient.put(url, data);
  },
  transferCustomers: (data) => {
    const url = `/staffs/transfer-customers`;
    return axiosClient.post(url, data);
  },
  changePassword: (data) => {
    const url = `/staffs/change-password`;
    return axiosClient.post(url, data);
  },
};

export default userApi;
